import Helper from './Helper';

class MainNavigation {
  constructor(config = {}) {
    const {
      mainNavSelector,
      menuTogglerSelector,
      menuContainerSelector,
      scndMenuContainerSelector,
      subMenuTogglerSelector
    } = config;

    this.mainNav = document.querySelector(mainNavSelector);
    this.menuToggler = document.querySelector(menuTogglerSelector);
    this.menuContainer = document.querySelector(menuContainerSelector);
    this.scndMenuContainer = document.querySelector(scndMenuContainerSelector);
    this.subMenuToggler = document.querySelectorAll(subMenuTogglerSelector);
    this.subMenuTogglerArray = Array.prototype.slice.call(this.subMenuToggler)
    this.body = document.querySelector('body');

    if(this.mainNav){
      this.bindEvents();
      this.checkIfHeaderWithImage();
    }
  }

  bindEvents(){
    this.menuToggler.addEventListener('click', e => {
      Helper.toggleClass(this.menuToggler, 'burger-active');
      Helper.toggleClass(this.menuContainer, 'is-open');
      Helper.toggleClass(this.scndMenuContainer, 'is-open');
      Helper.toggleClass(this.body, 'menu-open');
    });
    this.subMenuTogglerArray.forEach((toggler, i) => {
      toggler.addEventListener('click', e => {
        e.preventDefault();
        this.toggleSubmenu(toggler);
      });
    });
    this.mainNav.addEventListener('touchstart', e => {
      this.makeHeaderWhite(true);
    });
    this.mainNav.addEventListener('touchend', e => {
      this.makeHeaderWhite(false);
    });
    this.mainNav.addEventListener('mouseenter', e => {
      this.makeHeaderWhite(true);
    });
    this.mainNav.addEventListener('mouseleave', e => {
      this.makeHeaderWhite(false);
    });
  }

  toggleSubmenu(toggler){
    this.subMenuTogglerArray.forEach((toggle, i) => {
      if(toggle !== toggler){
        Helper.removeClass(toggle.parentElement, 'active');
        Helper.removeClass(toggle.nextElementSibling, 'active');
        Helper.slideUp(toggle.nextElementSibling);
        Helper.removeClass(this.body, 'submenu-open');
      }
    });
    Helper.toggleClass(toggler.parentElement, 'active');
    Helper.toggleClass(toggler.nextElementSibling, 'active');
    Helper.slideToggle(toggler.nextElementSibling);
    Helper.toggleClass(this.body, 'submenu-open');
  }

  checkIfHeaderWithImage(){
    const nextElement = this.mainNav.nextElementSibling;
    if(Helper.hasClass(nextElement, 'ns-header')){
      if(!Helper.hasClass(nextElement, 'no-image')){
        Helper.addClass(this.mainNav, 'transparent-header');
        this.makeHeaderWhite(false);
      }
    }
  }

  makeHeaderWhite(bool){
    if(bool){
      Helper.addClass(this.mainNav, 'site-header--white');
    } else {
      if(Helper.hasClass(this.mainNav, 'transparent-header')){
        Helper.removeClass(this.mainNav, 'site-header--white');
      }
    }
  }

}
export default MainNavigation;
